import { render, staticRenderFns } from "./SoldArticleComponent.vue?vue&type=template&id=b56f3efc&scoped=true&"
import script from "./SoldArticleComponent.vue?vue&type=script&lang=js&"
export * from "./SoldArticleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56f3efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBadge,VImg})
